<div class="mt-2 auction-filter">
  <div class="d-flex justify-content-lg-between justify-content-center align-items-center filter-heading">
    <h4>Filter by</h4>
    <button class="btn text-red d-none d-lg-flex" (click)="Clear()">Clear</button>
    <button class="btn d-lg-none shadow-none" (click)="OpenFilters()"><i class="fa fa-angle-down font-lg"></i></button>
  </div>
  <ul class="p-0 d-none d-lg-block filters" [ngClass]="{ 'd-block': IsFilterOpen }">
    <li>
      <auction-search-filter-item-text [model]="filters.keyword" (updated)="Updated('keyword')"></auction-search-filter-item-text>
    </li>
    <li>
      <auction-search-filter-item-choices [model]="filters.category" (updated)="Updated('category')"></auction-search-filter-item-choices>
    </li>
    <li>
      <auction-search-filter-item-text [model]="filters.lotNumber" (updated)="Updated('lotNumber')"></auction-search-filter-item-text>
    </li>
    <li>
      <auction-search-filter-item-range [model]="filters.price" (updated)="Updated('price')"></auction-search-filter-item-range>
    </li>
    <li>
      <auction-search-filter-item-choices [model]="filters.vintage" (updated)="Updated('vintage')"></auction-search-filter-item-choices>
    </li>
    <li>
      <auction-search-filter-item-choices [model]="filters.country" (updated)="Updated('country')"></auction-search-filter-item-choices>
    </li>
    <li>
      <auction-search-filter-item-choices [model]="filters.region" (updated)="RegionUpdated('region')"></auction-search-filter-item-choices>
    </li>
    <li>
      <auction-search-filter-item-choices [model]="filters.winery" (updated)="WineryUpdated()"></auction-search-filter-item-choices>
    </li>
    <li>
      <auction-search-filter-item-choices [model]="filters.variety" (updated)="Updated('variety')"></auction-search-filter-item-choices>
    </li>
    <li>
      <auction-search-filter-item-choices [model]="filters.unitOfMeasure" (updated)="Updated('uom')"></auction-search-filter-item-choices>
    </li>
    <li>
      <auction-search-filter-item-choices [model]="filters.excludeAttribute" (updated)="Updated('attr')"></auction-search-filter-item-choices>
    </li>
    <li>
      <auction-search-saved-filters [model]="customFilters" (applyFilter)="ApplyCustomFilter($event)" (deleteFilter)="DeleteCustomFilter($event)"></auction-search-saved-filters>
    </li>
  </ul>
  <button class="btn btn-primary btn-red mb-2 w-100 d-none d-lg-block" [disabled]="!stateService.userModel" (click)="CreateCustomFilter()" [ngClass]="{ 'd-block': IsFilterOpen }">Save Custom Filter</button>
</div>
